module.exports = __webpack_public_path__ + "static/media/sad.e311aeb5.svg";